import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { HrService } from 'src/app/services/hr/hr.service';

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';


@Component({
  selector: 'app-staff-allowances',
  templateUrl: './staff-allowances.component.html',
  styleUrls: ['./staff-allowances.component.css']
})
export class StaffAllowancesComponent implements OnInit {
  Submitted: boolean = false;
  SalaryComponentList = [];
  EmployeeList = [];

  constructor(private payrollService: HrService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  StaffAllowancesModel = {
    StaffID: 0,
    MonthID: 0,
    EmployeeCategoryID: 0,
    SalaryComponentID: 0,

  }



  GetSalaryComponent() {
    this.lookupservice.GetLookupsList('AllowancesComponent', '').subscribe((data: any) => {
      this.SalaryComponentList = data.LookupItems;
    });
  };

  Validate() {
    return this.StaffAllowancesModel.MonthID == 0||this.StaffAllowancesModel.SalaryComponentID == 0 ;
  }


  SaveStaffAllowances() {

    this.spinnerService.show();
    this.payrollService.SaveStaffAllowances(JSON.stringify(this.StaffAllowancesModel), JSON.stringify(this.EmployeeList)).subscribe((response: any) => {
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);
      if (response.webResponse.Status) {

        this.GetEmployeeAllowancesList();

      }
    });

  };

  ClearList(){
    this.EmployeeList=[];
  }
  GetEmployeeAllowancesList() {
    this.Submitted = true;
    if (!this.Validate()) {

      this.Submitted = false;
      this.spinnerService.show();
      this.payrollService.GetEmployeeAllowancesList(JSON.stringify(this.StaffAllowancesModel)).subscribe((data: any) => {
        this.EmployeeList = data.EmployeeList;
        this.spinnerService.hide();
      });
    }
  };
  EmployeeSalaryMappingModel = {
    StaffID: 0,

  }
  ComponentList = [];
  EmployeeCategoryList = [];
  GetSalaryComponentListByID() {
    this.payrollService.GetSalaryComponentListByID(this.EmployeeSalaryMappingModel.StaffID).subscribe((response: any) => {
      this.ComponentList = response.ComponentList;
      this.globalHelper.CheckActionStatus(response);
    });
  }

  YearList = [];


  GetEmployeeCategory() {
    this.lookupservice.GetLookupsList('EmployeeCategory', '').subscribe((data: any) => {
      this.EmployeeCategoryList = data.LookupItems;
    });
  };

  SalaryMonthList = [];
  GetSalaryMonth() {
    this.lookupservice.GetLookupsList('SalaryMonth', '').subscribe((data: any) => {
      this.SalaryMonthList = data.LookupItems;
    });
  };
  ngOnInit() {
    this.GetSalaryComponent();
    this.GetEmployeeCategory();
    this.GetSalaryMonth();

  };

}
